
/**
 * Supported cross-domain actions.
 * Keep all defined here since using enum.
 */
export enum XDActions {
    ACK,
    DELETE,
    GET,
    SET
}

/**
 * Resolver for cross domain message promise.
 */
export interface IXDResolver<T> {
    data?: T
    id: string
    resolve: (data: T) => void
}
